export default Object.freeze({
  MSRP: "MSRP",
  AVERAGE_RETAIL: "Average Retail",
  MANUFACTURER_PRICE: "Manufacturer Price",
  WHOLESALE_PRICE: "Wholesale Price",
  SALES_PRICE: "Sales Price",
  VEHICLE_PRICE: "Vehicle Price",
});
